export { default as LocalizationProvider } from './Provider';
export { default as useLocalization } from './hook';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/localization/index.js
// module id = 28
// module chunks = 0